<div [class]="containerClass">
  <lucide-icon name="search" [size]="24" class="hc-input__icon hc-input__icon--left" aria-hidden="true"></lucide-icon>
  <input
    type="text"
    [id]="inputId"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [value]="value"
    class="hc-input__native"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()" />
  @if (value) {
    <button type="button" class="hc-input__clear-btn" (click)="clear()" aria-label="Clear search">
      <lucide-icon name="x" [size]="18" aria-hidden="true"></lucide-icon>
    </button>
  }
</div>
